"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Necessary to polyfill ECMAScript features and transpiled generator functions
// needed for asynchronous operations.
// See https://babeljs.io/docs/en/babel-polyfill for more information.
require("core-js/stable");
require("regenerator-runtime/runtime.js");
require("../main");
